<header
  class="header navbar"
  [class.nav-scrolled]="isScrolled()"
  [class.header--transparent]="isHome() && !isScrolled()"
  [class.header--solid]="!isHome() || isScrolled()"
>
  <div class="container header-content">
    <div class="logo">
      <!-- Logo -->
      <div class="logo-wrapper">
        <img
          src="/lcys-logo-light-blue.svg"
          alt="LCYS Logo"
          onerror="this.src = '/lcys-logo-light-blue.png'"
        />
      </div>
    </div>

    <nav class="desktop-nav">
      <a *ngFor="let item of navItems" [routerLink]="item.route" class="nav-link">{{
        item.label
      }}</a>
    </nav>

    <div class="actions">
      <!-- Search hidden for now -->
      <div class="search-pill" *ngIf="false">
        <span class="placeholder">Search yachts..</span>
        <button class="search-icon-btn" aria-label="Search">
          <svg
            width="18"
            height="18"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            stroke-width="2"
          >
            <circle cx="11" cy="11" r="8"></circle>
            <path d="M21 21L16.65 16.65"></path>
          </svg>
        </button>
      </div>

      <button class="icon-btn cart-btn" aria-label="Cart" (click)="cartService.toggleCart()">
        <div class="badge" *ngIf="cartService.count() > 0">{{ cartService.count() }}</div>
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        >
          <circle cx="9" cy="21" r="1"></circle>
          <circle cx="20" cy="21" r="1"></circle>
          <path d="M1 1h4l2.68 13.39a2 2 0 0 0 2 1.61h9.72a2 2 0 0 0 2-1.61L23 6H6"></path>
        </svg>
      </button>

      <a routerLink="/admin/login" class="icon-btn user-btn" aria-label="User Account">
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          stroke-width="2"
        >
          <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"></path>
          <circle cx="12" cy="7" r="4"></circle>
        </svg>
      </a>
    </div>

    <!-- Mobile Toggle -->
    <button class="menu-toggle" (click)="toggleMenu()" aria-label="Toggle Menu">
      <span class="hamburger"></span>
    </button>
  </div>

  <!-- Mobile Menu -->
  <div class="mobile-menu" [class.open]="isMenuOpen">
    <nav>
      <a
        *ngFor="let item of navItems"
        [routerLink]="item.route"
        class="mobile-link"
        (click)="toggleMenu()"
      >
        {{ item.label | titlecase }}
      </a>
    </nav>
  </div>
</header>
